import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { connectMediaStore } from './withOwnReduxStore';
import { initMediaPopup } from '../actions';
import { normalizeDeviation, normalizeGallection } from '../../redux/normalizr/helpers';
export default connectMediaStore(null, (dispatch)=>({
        initMediaPopup: (payload)=>{
            const { gallectionFolder, tier } = payload;
            let entities;
            if (gallectionFolder) {
                entities = normalizeGallection(gallectionFolder);
            } else if (tier) {
                entities = normalizeDeviation(tier);
            }
            dispatch(initMediaPopup(_object_spread_props(_object_spread({}, payload), {
                entities
            })));
        }
    }));

//# sourceMappingURL=withMediaPopupInit.js.map